/*
 * Ficha de regalar. Los packs son los bundles «Regalo» de la app Happymami: los pide a
 * /apps/hm-menus/bundles?mode=gift&detail=1, deja elegir pack y color, y añade las piezas al carrito
 * con el mismo _bundle_id. El precio del pack lo cobra la función de checkout; los códigos de las
 * tetinas los reserva la app al pagar el pedido.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root.document) {
    var el = root.document.querySelector('[data-hm-regalar]');
    if (el) api.boot(el);
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var COLOR_RE = /colou?r|tono|colore|farbe|^cor$|couleur|kolor/i;
  var CAP_RE = /capacidad|capacity|capacit|tama|size|volum|gr[oö]/i;
  var CUP_ROLES = { biberon: 1, vaso: 1, taza: 1 };

  function lower(value) {
    return String(value || '').trim().toLowerCase();
  }

  function fill(text, vars) {
    return String(text || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (all, key) {
      return vars && vars[key] != null ? vars[key] : '';
    });
  }

  function optionIndex(item, re) {
    var names = (item && item.options) || [];
    for (var i = 0; i < names.length; i += 1) if (re.test(names[i])) return i;
    return -1;
  }

  function capIndex(item) {
    var byName = optionIndex(item, CAP_RE);
    if (byName >= 0) return byName;
    var variants = (item && item.variants) || [];
    var names = (item && item.options) || [];
    for (var i = 0; i < names.length; i += 1) {
      if (variants.length && variants.every(function (v) { return /\d\s*ml/i.test(v.options[i] || ''); })) return i;
    }
    return -1;
  }

  function capNumber(value) {
    var match = /(\d+(?:[.,]\d+)?)/.exec(String(value || ''));
    return match ? Number(match[1].replace(',', '.')) : 0;
  }

  /** Variants this slot may use (the app can limit a slot to some variants). */
  function allowed(slot, item) {
    var only = (slot.variants || []).map(String);
    return (item.variants || []).filter(function (variant) {
      return !only.length || only.indexOf(String(variant.id)) >= 0;
    });
  }

  /** True when the slot's piece is chosen by colour (more than one colour among its variants). */
  function colorable(slot, item) {
    var index = optionIndex(item, COLOR_RE);
    if (index < 0) return false;
    var seen = {};
    allowed(slot, item).forEach(function (variant) {
      seen[lower(variant.options[index])] = 1;
    });
    return Object.keys(seen).length > 1;
  }

  function firstItem(slot, color) {
    var items = slot.items || [];
    if (!color) return items[0] || null;
    for (var i = 0; i < items.length; i += 1) {
      var index = optionIndex(items[i], COLOR_RE);
      if (index < 0) continue;
      var hit = allowed(slot, items[i]).some(function (v) { return lower(v.options[index]) === lower(color); });
      if (hit) return items[i];
    }
    return items[0] || null;
  }

  /** Packs sold as one product: what is inside, by SKU prefix (R2BTD-M/R/V = Pack de regalo completo). */
  var KITS = { R2BTD: ['cups', 'termo', 'dosificador'] };

  function kitOf(variant) {
    var sku = String((variant && variant.sku) || '').toUpperCase();
    var prefix = sku.split('-')[0];
    return KITS[prefix] || null;
  }

  function tipoOf(slot, variant) {
    var role = lower(slot.role);
    if (CUP_ROLES[role]) return 'taza';
    if (role === 'tetina') return 'reserva';
    if (role === 'otro') {
      var sku = String((variant && variant.sku) || '').toUpperCase();
      if (sku === 'REGALO-ASESORIA' || sku === 'AM') return 'asesoria';
      if (sku.indexOf('REGALO-AJUSTE') === 0) return 'ajuste';
      return 'otro';
    }
    return role || 'otro';
  }

  /**
   * The cart lines for a pack in one colour, or { error } naming what is missing.
   * Several cups of a product with capacities alternate them (150 ml + 250 ml).
   */
  function resolvePack(pack, color) {
    var lines = [];
    for (var s = 0; s < pack.slots.length; s += 1) {
      var slot = pack.slots[s];
      var item = firstItem(slot, color);
      if (!item) return { error: 'missing', slot: s };
      var candidates = allowed(slot, item);
      var colorAt = optionIndex(item, COLOR_RE);
      var byColor = colorable(slot, item);
      if (byColor) {
        candidates = candidates.filter(function (v) { return lower(v.options[colorAt]) === lower(color); });
      }
      var capAt = capIndex(item);
      var caps = [];
      if (capAt >= 0 && slot.qty > 1) {
        candidates.forEach(function (v) {
          var cap = v.options[capAt];
          if (caps.indexOf(cap) < 0) caps.push(cap);
        });
        caps.sort(function (a, b) { return capNumber(a) - capNumber(b); });
      }
      var picks = [];
      if (caps.length > 1) {
        for (var q = 0; q < slot.qty; q += 1) {
          var cap = caps[q % caps.length];
          var hit = candidates.filter(function (v) { return v.options[capAt] === cap && v.available; })[0];
          if (!hit) return { error: 'soldout', slot: s, item: item };
          picks.push(hit);
        }
      } else {
        var one = candidates.filter(function (v) { return v.available; })[0];
        if (!one) return { error: 'soldout', slot: s, item: item };
        for (var k = 0; k < slot.qty; k += 1) picks.push(one);
      }
      picks.forEach(function (variant) {
        var last = lines[lines.length - 1];
        if (last && last.slot === s && last.variant.id === variant.id) {
          last.quantity += 1;
          return;
        }
        lines.push({
          slot: s,
          role: lower(slot.role),
          tipo: tipoOf(slot, variant),
          item: item,
          variant: variant,
          quantity: 1,
          color: byColor ? variant.options[colorAt] : '',
          capacity: capAt >= 0 ? variant.options[capAt] : '',
        });
      });
    }
    return { lines: lines };
  }

  /** Colours offered for a pack: the ones every coloured piece has, in the cups' order. */
  function packColors(pack) {
    var lists = [];
    pack.slots.forEach(function (slot) {
      (slot.items || []).slice(0, 1).forEach(function (item) {
        if (!colorable(slot, item)) return;
        var index = optionIndex(item, COLOR_RE);
        var names = [];
        allowed(slot, item).forEach(function (v) {
          var name = v.options[index];
          if (names.map(lower).indexOf(lower(name)) < 0) names.push(name);
        });
        lists.push({ cup: !!CUP_ROLES[lower(slot.role)], names: names });
      });
    });
    if (!lists.length) return [];
    lists.sort(function (a, b) { return (b.cup ? 1 : 0) - (a.cup ? 1 : 0); });
    return lists[0].names.filter(function (name) {
      return lists.every(function (list) { return list.names.map(lower).indexOf(lower(name)) >= 0; });
    });
  }

  /** What the pack includes, in the visitor's language. */
  function includesOf(pack, copy) {
    var rows = [];
    pack.slots.forEach(function (slot) {
      var role = lower(slot.role);
      var item = (slot.items || [])[0];
      if (CUP_ROLES[role]) {
        var sizes = [];
        if (item && slot.qty > 1) {
          var capAt = capIndex(item);
          if (capAt >= 0) {
            allowed(slot, item).forEach(function (v) {
              var cap = String(v.options[capAt] || '').replace(/\s*ml$/i, ' ml').replace(/(\d)ml/i, '$1 ml');
              if (sizes.indexOf(cap) < 0) sizes.push(cap);
            });
            sizes.sort(function (a, b) { return capNumber(a) - capNumber(b); });
          }
        }
        var label = slot.qty > 1 ? fill(copy.cups, { count: slot.qty }) : copy.cup;
        rows.push(sizes.length > 1 && sizes.length <= slot.qty ? label + ' (' + sizes.join(' + ') + ')' : label);
        return;
      }
      if (role === 'tetina') return;
      var variant = item ? allowed(slot, item)[0] : null;
      var tipo = tipoOf(slot, variant);
      if (tipo === 'ajuste') return;
      var kit = kitOf(variant);
      if (kit) {
        kit.forEach(function (key) {
          rows.push(key === 'cups' ? fill(copy.cups, { count: 2 }) + ' (150 ml + 250 ml)' : copy[key]);
        });
        return;
      }
      var text = tipo === 'asesoria' ? copy.asesoria : copy[role] || (item ? item.title : '');
      if (!text) return;
      rows.push(slot.qty > 1 ? slot.qty + '× ' + text : text);
    });
    var teats = pack.gift ? Number(pack.gift.tetinas) || 0 : 0;
    if (teats > 0) rows.push({ teats: true, text: teats > 1 ? fill(copy.teats, { count: teats }) : copy.teat });
    return rows;
  }

  function savingCents(pack) {
    var compare = Number(pack.compareCents) || 0;
    var price = Number(pack.priceCents) || 0;
    return compare > price && price > 0 ? compare - price : 0;
  }

  function money(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale || 'es', {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: cents % 100 ? 2 : 0,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function uuid() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    return 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  /** Cart lines for /cart/add.js, all sharing the bundle id the checkout groups by. */
  function cartItems(pack, resolved, colorLabel, locale) {
    var bundle = uuid();
    var teats = pack.gift ? String(Number(pack.gift.tetinas) || 0) : '0';
    return resolved.lines.map(function (line) {
      var props = {
        _bundle_id: bundle,
        _bundle_title: pack.title,
        _hm_pack: pack.id,
        _gift_pack: pack.id,
        _gift_tetinas: teats,
        _tipo: line.tipo,
        _hm_locale: locale || 'es',
      };
      if (line.color) props.Color = colorLabel || line.color;
      if (line.tipo === 'taza' && line.capacity) props.Capacidad = line.capacity;
      return { id: Number(line.variant.id), quantity: line.quantity, properties: props };
    });
  }

  var CHECK =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5.5 12.5c1.6 1.4 2.9 2.8 4 4.2 2.4-3.9 5.2-7.1 8.9-9.9"/></svg>';
  var QR_MINI =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="2.2"/><rect x="14" y="3" width="7" height="7" rx="2.2"/><rect x="3" y="14" width="7" height="7" rx="2.2"/><path d="M14 14.6c0-.4.3-.6.6-.6h1.6"/><path d="M19.6 14h.8c.3 0 .6.3.6.6v1.2"/><path d="M14 18.4v2c0 .3.3.6.6.6h1.6"/><path d="M21 19.6v.8c0 .3-.3.6-.6.6h-1"/></svg>';

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function boot(rootEl) {
    var dataEl = rootEl.querySelector('[data-hm-rg-data]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var copy = data.copy || {};
    var packsEl = rootEl.querySelector('[data-hm-rg-packs]');
    var colorBox = rootEl.querySelector('[data-hm-rg-color]');
    var colorName = rootEl.querySelector('[data-hm-rg-color-name]');
    var swatchesEl = rootEl.querySelector('[data-hm-rg-swatches]');
    var qrText = rootEl.querySelector('[data-hm-rg-qr-text]');
    var button = rootEl.querySelector('[data-hm-rg-add]');
    var buttonLabel = rootEl.querySelector('[data-hm-rg-add-label]');
    var buttonPrice = rootEl.querySelector('[data-hm-rg-add-price]');
    var statusEl = rootEl.querySelector('[data-hm-rg-status]');
    var bar = rootEl.querySelector('[data-hm-rg-bar]');
    var barTitle = rootEl.querySelector('[data-hm-rg-bar-title]');
    var barPrice = rootEl.querySelector('[data-hm-rg-bar-price]');
    var barButton = rootEl.querySelector('[data-hm-rg-bar-add]');
    var buyEl = rootEl.querySelector('#hm-regalar-packs');
    var state = { packs: [], pack: null, color: '', busy: false, seen: false };
    var labels = {};
    var lastMedia = null;

    /** Localised names and swatch colours of the page product's colours (same order as in the admin). */
    function learnColors(packs) {
      var mine = String(data.productId);
      packs.forEach(function (pack) {
        pack.slots.forEach(function (slot) {
          (slot.items || []).forEach(function (item) {
            (item.optionValues || []).forEach(function (option) {
              if (!COLOR_RE.test(option.name)) return;
              option.values.forEach(function (value, index) {
                var local = String(item.id) === mine ? (data.colors || [])[index] : null;
                var key = lower(value.name);
                var known = labels[key] || {};
                labels[key] = {
                  label: (local && local.label) || known.label || value.name,
                  hex: value.color || (local && local.hex) || known.hex || '',
                };
              });
            });
          });
        });
      });
    }

    function labelOf(name) {
      return (labels[lower(name)] && labels[lower(name)].label) || name;
    }

    function hexOf(name) {
      return (labels[lower(name)] && labels[lower(name)].hex) || '#d0d5dd';
    }

    function colorsOf(pack) {
      return pack ? packColors(pack) : [];
    }

    function pickColor() {
      var list = colorsOf(state.pack);
      if (!list.length) {
        state.color = '';
        return;
      }
      var keep = list.filter(function (name) { return lower(name) === lower(state.color); })[0];
      if (keep && !resolvePack(state.pack, keep).error) {
        state.color = keep;
        return;
      }
      var ok = list.filter(function (name) { return !resolvePack(state.pack, name).error; })[0];
      state.color = ok || list[0];
    }

    function withGallery(fn) {
      var gallery = rootEl.querySelector('media-gallery');
      if (gallery && typeof gallery.setActiveMedia === 'function') return fn(gallery);
      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('media-gallery').then(function () {
          var ready = rootEl.querySelector('media-gallery');
          if (ready && typeof ready.setActiveMedia === 'function') fn(ready);
        });
      }
    }

    function showColorMedia(resolved) {
      if (!resolved || !resolved.lines) return;
      var media = null;
      // Foto del pack en ese color elegida en la app (Bundles → Fotos por color), si la hay.
      var photos = state.pack && state.pack.colorMedia;
      var photo = photos && (photos[String(state.color || '').toLowerCase()] || photos['*']);
      if (photo && photo.id) media = photo.id;
      if (!media) resolved.lines.some(function (line) {
        var id = data.media && data.media[String(line.variant.id)];
        if (id) media = id;
        return !!id;
      });
      if (!media || media === lastMedia) return;
      lastMedia = media;
      withGallery(function (gallery) {
        gallery.setActiveMedia(String(data.sectionId) + '-' + String(media), false, false);
      });
    }

    function renderPacks() {
      packsEl.innerHTML = '';
      state.packs.forEach(function (pack) {
        var on = pack === state.pack;
        var save = savingCents(pack);
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'hm-rg-pack' + (on ? ' is-selected' : '');
        card.setAttribute('role', 'radio');
        card.setAttribute('aria-checked', on ? 'true' : 'false');
        card.tabIndex = on ? 0 : -1;
        card.style.setProperty('--hm-rg-accent', pack.color || '#f49898');
        // Estilo que se edita en la app (vacío = el del tema).
        [
          ['--hm-rg-border', pack.borderColor],
          ['--hm-rg-badge-bg', pack.badgeColor],
          ['--hm-rg-banner-color', pack.bannerColor],
          ['--hm-rg-badge-size', pack.badgeSize ? pack.badgeSize + 'px' : ''],
          ['--hm-rg-banner-size', pack.bannerSize ? pack.bannerSize + 'px' : ''],
          ['--hm-rg-sub-size', pack.subtitleSize ? pack.subtitleSize + 'px' : ''],
        ].forEach(function (rule) {
          if (rule[1]) card.style.setProperty(rule[0], rule[1]);
        });
        var rows = includesOf(pack, copy)
          .map(function (row) {
            if (typeof row === 'string') return '<li>' + CHECK + '<span>' + esc(row) + '</span></li>';
            return '<li class="is-gift">' + QR_MINI + '<span>' + esc(row.text) + '</span></li>';
          })
          .join('');
        card.innerHTML =
          (pack.badge ? '<span class="hm-rg-pack__badge">' + esc(pack.badge) + '</span>' : '') +
          '<span class="hm-rg-pack__radio" aria-hidden="true"></span>' +
          '<span class="hm-rg-pack__main">' +
          '<span class="hm-rg-pack__title">' + esc(pack.title) + '</span>' +
          (pack.subtitle ? '<span class="hm-rg-pack__sub">' + esc(pack.subtitle) + '</span>' : '') +
          '<ul class="hm-rg-pack__inc">' + rows + '</ul>' +
          (on && pack.banner ? '<span class="hm-rg-pack__banner">' + esc(pack.banner) + '</span>' : '') +
          '</span>' +
          '<span class="hm-rg-pack__price">' +
          (pack.compare ? '<s>' + esc(pack.compare) + '</s>' : '') +
          '<b>' + esc(pack.price) + '</b>' +
          (save ? '<em>' + esc(fill(copy.save, { amount: money(save, pack.currency, data.locale) })) + '</em>' : '') +
          '</span>';
        card.addEventListener('click', function () {
          if (state.pack === pack) return;
          state.pack = pack;
          pickColor();
          render();
        });
        packsEl.appendChild(card);
      });
    }

    function renderColors() {
      var list = colorsOf(state.pack);
      colorBox.hidden = list.length < 2;
      swatchesEl.innerHTML = '';
      list.forEach(function (name) {
        var on = lower(name) === lower(state.color);
        var soldOut = !!resolvePack(state.pack, name).error;
        var swatch = document.createElement('button');
        swatch.type = 'button';
        swatch.className = 'hm-rg__swatch' + (on ? ' is-selected' : '') + (soldOut ? ' is-soldout' : '');
        swatch.setAttribute('role', 'radio');
        swatch.setAttribute('aria-checked', on ? 'true' : 'false');
        swatch.setAttribute('aria-label', labelOf(name) + (soldOut ? ' · ' + (copy.soldOut || '') : ''));
        swatch.title = labelOf(name);
        swatch.style.setProperty('--swatch', hexOf(name));
        swatch.addEventListener('click', function () {
          state.color = name;
          render();
        });
        swatchesEl.appendChild(swatch);
      });
      colorName.textContent = state.color ? labelOf(state.color) : '';
    }

    function render() {
      var focused = document.activeElement;
      var refocus = focused && packsEl.contains(focused) ? 'pack' : focused && swatchesEl.contains(focused) ? 'color' : '';
      renderPacks();
      renderColors();
      if (refocus === 'pack') {
        var current = packsEl.querySelector('[aria-checked="true"]');
        if (current) current.focus({ preventScroll: true });
      } else if (refocus === 'color') {
        var sw = swatchesEl.querySelector('[aria-checked="true"]');
        if (sw) sw.focus({ preventScroll: true });
      }
      var pack = state.pack;
      var resolved = pack ? resolvePack(pack, state.color) : { error: 'missing' };
      var teats = pack && pack.gift ? Number(pack.gift.tetinas) || 0 : 0;
      if (qrText) qrText.textContent = teats === 1 ? copy.qrOne : fill(copy.qrMany, { count: teats || 2 });
      var soldOut = !!resolved.error;
      button.disabled = state.busy || soldOut;
      buttonLabel.textContent = soldOut ? copy.soldOut : state.busy ? copy.adding : copy.add;
      buttonPrice.textContent = pack && !soldOut ? pack.price : '';
      barTitle.textContent = pack ? pack.title + (state.color ? ' · ' + labelOf(state.color) : '') : '';
      barPrice.textContent = pack ? pack.price : '';
      barButton.disabled = state.busy || soldOut;
      barButton.textContent = soldOut ? copy.soldOut : copy.add;
      statusEl.textContent = '';
      if (!soldOut) showColorMedia(resolved);
    }

    function cartTarget() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    function add() {
      if (state.busy || !state.pack) return;
      var resolved = resolvePack(state.pack, state.color);
      if (resolved.error) {
        statusEl.textContent = copy.soldOut;
        return;
      }
      var cart = cartTarget();
      var payload = { items: cartItems(state.pack, resolved, labelOf(state.color), data.locale) };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map(function (section) { return section.id; });
        payload.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      state.busy = true;
      render();
      fetch(data.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload),
      })
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok) throw new Error(body.description || body.message || copy.error);
            return body;
          });
        })
        .then(function (body) {
          state.busy = false;
          render();
          if (window.publish && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'hm-regalar', cartData: body });
          }
          if (cart && typeof cart.renderContents === 'function' && body.sections) {
            if (!body.key && body.items && body.items[0]) body.key = body.items[0].key;
            cart.classList.remove('is-empty');
            cart.renderContents(body);
            return;
          }
          window.location.href = data.cartUrl;
        })
        .catch(function (error) {
          state.busy = false;
          render();
          statusEl.textContent = (error && error.message) || copy.error;
        });
    }

    function onBar() {
      if (!state.seen && buyEl) {
        buyEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      add();
    }

    function watch() {
      if (!('IntersectionObserver' in window) || !bar) return;
      var ctaVisible = true;
      var packsVisible = false;
      function update() {
        var show = !!state.pack && !ctaVisible && !packsVisible;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        barButton.tabIndex = show ? 0 : -1;
        document.documentElement.classList.toggle('hm-rg-bar-on', show);
      }
      new IntersectionObserver(function (entries) {
        ctaVisible = entries[0].isIntersecting;
        update();
      }).observe(button);
      new IntersectionObserver(function (entries) {
        packsVisible = entries[0].isIntersecting;
        if (packsVisible) state.seen = true;
        update();
      }, { threshold: 0.25 }).observe(packsEl);
    }

    packsEl.addEventListener('keydown', function (event) {
      var keys = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
      if (!keys[event.key] || !state.packs.length) return;
      event.preventDefault();
      var index = state.packs.indexOf(state.pack);
      state.pack = state.packs[(index + keys[event.key] + state.packs.length) % state.packs.length];
      pickColor();
      render();
    });
    swatchesEl.addEventListener('keydown', function (event) {
      var keys = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
      var list = colorsOf(state.pack);
      if (!keys[event.key] || !list.length) return;
      event.preventDefault();
      var index = list.map(lower).indexOf(lower(state.color));
      state.color = list[(index + keys[event.key] + list.length) % list.length];
      render();
    });
    button.addEventListener('click', add);
    if (barButton) barButton.addEventListener('click', onBar);

    fetch(data.packsUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (remote) {
        var packs = ((remote && remote.packs) || []).filter(function (pack) {
          return (pack.slots || []).length && pack.slots.every(function (slot) { return slot.items && slot.items.length; });
        });
        if (!packs.length) throw new Error('empty');
        learnColors(packs);
        state.packs = packs;
        state.pack = packs.filter(function (pack) { return pack.id === remote.defaultPack; })[0] || packs[0];
        pickColor();
        render();
        watch();
      })
      .catch(function () {
        packsEl.innerHTML = '<p class="hm-rg__empty">' + esc(copy.empty) + '</p>';
        buttonLabel.textContent = copy.soldOut;
      });
  }

  return {
    resolvePack: resolvePack,
    packColors: packColors,
    includesOf: includesOf,
    cartItems: cartItems,
    savingCents: savingCents,
    money: money,
    boot: boot,
  };
});
